export const SHARE_PROTOCOL = 'atom'
export const FONT_ALIAS = {
  clanProNarrBold: 'clanProNarrBoldAlias',
  clanProNarrBook: 'clanProNarrBookAlias',
}